/**
 * Route for `datacenter-traffic-block-aws-gcp-azure-ip-blacklist`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { DatacenterTrafficBlockAwsGcpAzureIpBlacklistPage } from "../features/datacenter-traffic-block-aws-gcp-azure-ip-blacklist/DatacenterTrafficBlockAwsGcpAzureIpBlacklistPage";

export const datacenterTrafficBlockAwsGcpAzureIpBlacklistRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/datacenter-traffic-block-aws-gcp-azure-ip-blacklist",
	component: DatacenterTrafficBlockAwsGcpAzureIpBlacklistPage,
});

export default datacenterTrafficBlockAwsGcpAzureIpBlacklistRoute;
